// @flow

import React, { Component } from "react";
import $ from "jquery";
import FlatButton from "material-ui/FlatButton";
import { Tabs, Tab } from "material-ui/Tabs";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import SwipeableViews from "react-swipeable-views";
// import CircularProgress from 'material-ui/CircularProgress';
import Toggle from "material-ui/Toggle";
import { Icon } from "react-fa";
import Alert from "react-s-alert";
import _ from "lodash";
import moment from "moment";
import Draggable from "react-draggable";
// import AmCharts from '@amcharts/amcharts3-react';
import * as ExcelJs from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { setHeaderExcel, setTitlesStyles } from "./imgExcel.js";

import App from "./App.jsx";
import Map from "./Map.jsx";
import Toolbar from "./Toolbar.jsx";
import DialogSensorUPL from "./DialogSensorUPL.jsx";

import { CLASSIC_WIDTH, SIDEBAR_WIDTH } from "./consts.js";

import { no_rclick } from "./utils.js";

import type { T_Sen, T_SenAlerta } from "./types.js";

import "react-quill/dist/quill.snow.css";

import "./css/DialogSensor.css";

import { fetch_shp } from "./fetch_things.js";

import HoraFrio from "./charts/HoraFrio.js";
// import DualLine from './charts/DualLine';
import Base10 from "./charts/Base10.js";
import EvapoPre from "./charts/EvapoPre.js";
import Evapo from "./charts/Evapo.js";
import Precipitacion from "./charts/Precipitacion.js";
import Temperatura from "./charts/Temperatura.js";
import Humedad from "./charts/Humedad.js";
import DPV from "./charts/DPV.js";
import MojaHoja from "./charts/MojaHoja.js";
// import { center } from 'underscore.string';
// import { Toolbar } from 'material-ui';
/* import EvapoPrec from './charts/EvapoPrec.js';
import Column from './charts/Column';
import Line from './charts/Line'; */

// Import Icons
// const iconFito = require('../src/css/img/hoja_fito.png');
// const iconHelada = require('../src/css/img/iStock-1019279730.jpg');
const iconClimaSense = require("../src/css/img/logos/Climasense_blanco.png"),
  iconUPL = require("../src/css/img/logos/upl_blanco.png");
const tooltip = require("../src/css/img/tooltip.svg");

const validator = require("email-validator");
const accuKey = "G6tdCYAsGbuNbDf3SLN0It9gRlm0Ag3X";

/* eslint-disable no-use-before-define */

type T_CustomTabsProps = {
  alertas: Array<T_SenAlerta>,
  parent: DialogSensor,
};

/* eslint-enable no-use-before-define */

type T_CustomTabsState = {
  tab: number,
  superficie: number,
  cultivo: string,
  especie: string,
  alertas: Array<T_SenAlerta>,
  nombre_error: string,
  email_error: string,
  temp_error: string,
  hum_error: string,
  msg: string,
};

class CustomTabs extends Component<T_CustomTabsProps, T_CustomTabsState> {
  save: () => void;
  validateNumber: (ev: SyntheticInputEvent<*>) => void;
  changeTab: (ev: SyntheticInputEvent<*>) => void;
  changeNombre: (ev: SyntheticInputEvent<*>) => void;
  changeEmail: (ev: SyntheticInputEvent<*>) => void;
  changeTemp: (ev: SyntheticInputEvent<*>) => void;
  changeHum: (ev: SyntheticInputEvent<*>) => void;
  /* changeRadGlobal : (ev: SyntheticInputEvent<*>) => void;
  changeRadDirecta: (ev: SyntheticInputEvent<*>) => void;
  changeRadPre    : (ev: SyntheticInputEvent<*>) => void; */
  changeOptTemp: (ev: SyntheticInputEvent<*>) => void;
  changeOptHum: (ev: SyntheticInputEvent<*>) => void;
  changeEstado: (ev: SyntheticInputEvent<*>) => void;

  constructor(props: T_CustomTabsProps) {
    super(props);

    this.state = {
      tab: 0,
      superficie: 0,
      cultivo: "",
      especie: "",
      alertas: this.props.alertas,
      nombre_error: "",
      email_error: "",
      temp_error: "",
      hum_error: "",
      msg: "",
    };

    this.validateNumber = this.validateNumber.bind(this);
    this.save = this.save.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.changeNombre = this.changeNombre.bind(this);
    this.changeEmail = this.changeEmail.bind(this);
    this.changeTemp = this.changeTemp.bind(this);
    this.changeHum = this.changeHum.bind(this);
    /* this.changeRadGlobal  = this.changeRadGlobal.bind(this);
    this.changeRadDirecta = this.changeRadDirecta.bind(this);
    this.changePre        = this.changePre.bind(this); */
    this.changeOptTemp = this.changeOptTemp.bind(this);
    this.changeOptHum = this.changeOptHum.bind(this);
    this.changeEstado = this.changeEstado.bind(this);
    // this.removeAlert      = this.removeAlert.bind(this);
    // this.removeAlert();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.alertas !== nextProps.alertas) {
      this.setState({
        alertas: nextProps.alertas,
        nombre_error: "",
        email_error: "",
        temp_error: "",
        hum_error: "",
        msg: "",
      });
    }
  }

  save(): void {
    this.props.parent.setState({
      isLoading: true,
    });

    const { tab } = this.state,
      alerta = this.state.alertas[tab],
      valid_email = validator.validate(alerta.email),
      { sen, lat, lng } = this.props.parent.state,
      superficie = parseFloat(this.state.superficie),
      especie = this.state.especie;

    if (
      alerta.nombre !== "" &&
      alerta.email !== "" &&
      valid_email &&
      alerta.temp_ref > 0 &&
      alerta.hum_ref > 0 &&
      sen.titulo !== ""
    ) {
      const { app } = this.props.parent.props;

      alerta.temp_ref = parseFloat(alerta.temp_ref);
      alerta.hum_ref = parseFloat(alerta.hum_ref);

      sen.alertas[tab] = alerta;

      if (sen.file === "") {
        sen.lat = lat;
        sen.lng = lng;
        sen.especie = especie;
        sen.superficie = superficie;
        /* eslint-disable prefer-template */
        sen.file = `${sen.titulo.replace(/ /g, "_")}-${Date.now()}-${(
          Math.random() + ""
        ).slice(2)}.sensor`;
        /* eslint-enable prefer-template */
        sen.path = `${sen.dir}/${sen.file}`;
      }

      $.ajax({
        type: "POST",
        url: `${app.remote}/post-sensor/?session_id=${app.session()}&path=${
          sen.path
        }&id_alerta=${alerta.id}&tab=${this.state.tab}`,
        dataType: "json",
        async: true,
        data: { sensor: JSON.stringify(sen) },
      })
        .done(async (res) => {
          if (res.error) {
            Alert.error("No se pudo guardar la alerta.", {
              position: "bottom-left",
            });

            this.setState({
              nombre_error: "",
              email_error: "",
              temp_error: "",
              hum_error: "",
              msg: "No se pudo guardar la alerta.",
            });

            await this.props.parent.setState({
              isLoading: false,
              titulo_error: "",
            });
          } else {
            await app.reload_dir(sen.dir, (resp) => {
              const item_sen = app.get_item_sen(res.sensor.path);

              if (item_sen != null) {
                item_sen.open();
              }
            });
            this.props.parent.setState({
              isLoading: false,
            });
            if (sen.id === 0) {
              Alert.success("Sensor creado con exito", {
                position: "bottom-left",
              });
            } else if (alerta.id > 0) {
              Alert.success("Alerta modificada con exito", {
                position: "bottom-left",
              });
            } else {
              Alert.success("Alerta creada con exito", {
                position: "bottom-left",
              });
            }
          }
        })
        .fail((err) => {
          this.setState({
            nombre_error: "",
            email_error: "",
            temp_error: "",
            hum_error: "",
            msg: "Hubo un error en el proceso",
          });

          Alert.error("Hubo un error en el proceso", {
            position: "bottom-left",
          });

          this.props.parent.setState({
            isLoading: false,
            titulo_error: "",
          });
        });
    } else {
      this.props.parent.setState({ isLoading: false });

      if (sen.titulo === "") {
        this.props.parent.setState({
          titulo_error: "Ingrese un titulo para el sensor",
        });
      }

      if (alerta.nombre === "") {
        this.setState({ nombre_error: "Ingrese un nombre de alerta" });
      }

      if (!valid_email) {
        this.setState({ email_error: "Ingrese un e-mail de alerta" });
      }

      if (alerta.temp_ref < 0) {
        this.setState({ temp_error: "Ingrese un valor de temperatura válido" });
      }

      if (alerta.hum_ref < 0) {
        this.setState({ hum_error: "Ingrese un valor de humedad válido" });
      }
    }
  }

  validateNumber(ev): void {
    // const re = /[0-9,.-]+/g;
    const re = /[0-9-]/g;
    if (!re.test(ev.key)) {
      ev.preventDefault();
    }
  }

  changeTab(tab: number): void {
    if (tab !== this.state.tab) {
      const alerta = this.state.alertas[tab];

      this.setState({
        tab,
        nombre_error: "",
        email_error: "",
        temp_error: "",
        hum_error: "",
        msg: "",
      });

      if (this.props.parent.state.alerta !== alerta) {
        this.props.parent.setState({
          alerta,
        });
      }
    }
  }

  changeNombre(ev: SyntheticInputEvent<*>): void {
    const alertas = _.cloneDeep(this.state.alertas),
      newAlerta = alertas[this.state.tab];

    newAlerta.nombre = ev.target.value;
    alertas[this.state.tab] = newAlerta;

    this.setState({
      alertas,
      nombre_error: "",
    });
  }

  changeEmail(ev: SyntheticInputEvent<*>): void {
    const alertas = _.cloneDeep(this.state.alertas),
      newAlerta = alertas[this.state.tab];

    newAlerta.email = ev.target.value;
    alertas[this.state.tab] = newAlerta;

    this.setState({
      alertas,
      email_error: "",
    });
  }

  changeTemp(ev: SyntheticInputEvent<*>): void {
    const alertas = _.cloneDeep(this.state.alertas),
      newAlerta = alertas[this.state.tab],
      temp = ev.target.value.replace(/,/g, ".");

    if (temp !== "") {
      if (/^[-+]?\d*.?\d*$/.test(temp)) {
        newAlerta.temp_ref = parseFloat(temp);
        alertas[this.state.tab] = newAlerta;
      }
    } else {
      newAlerta.temp_ref = 0;
    }

    alertas[this.state.tab] = newAlerta;

    this.setState({
      alertas,
      temp_error: "",
    });
  }

  changeHum(ev: SyntheticInputEvent<*>): void {
    const alertas = _.cloneDeep(this.state.alertas),
      newAlerta = alertas[this.state.tab],
      hum = ev.target.value.replace(/,/g, ".");

    if (hum !== "") {
      if (/^[-+]?\d*.?\d*$/.test(hum)) {
        newAlerta.hum_ref = parseFloat(hum);
        alertas[this.state.tab] = newAlerta;
      }
    } else {
      newAlerta.hum_ref = 0;
    }

    alertas[this.state.tab] = newAlerta;

    this.setState({
      alertas,
      hum_error: "",
    });
  }

  /* changeRadGlobal(ev: SyntheticInputEvent<*>): void {
    const alertas = _.cloneDeep(this.state.alertas);
    const newAlerta = alertas[this.state.tab];
    newAlerta.rad_global_ref = ev.target.value.replace(/,/g, '.');
    if (/^[-+]?\d*.?\d*$/.test(newAlerta.rad_global_ref)) {
      alertas[this.state.tab] = newAlerta;
      this.setState({
        alertas
      });
    }
  }



  changeRadDirecta(ev: SyntheticInputEvent<*>): void {
    const alertas = _.cloneDeep(this.state.alertas);
    const newAlerta = alertas[this.state.tab];
    newAlerta.rad_directa_ref = ev.target.value.replace(/,/g, '.');
    if (/^[-+]?\d*.?\d*$/.test(newAlerta.rad_directa_ref)) {
      alertas[this.state.tab] = newAlerta;
      this.setState({
        alertas
      });
    }
  }



  changePre(ev: SyntheticInputEvent<*>): void {
    const alertas = _.cloneDeep(this.state.alertas);
    const newAlerta = alertas[this.state.tab];
    newAlerta.pre_ref = ev.target.value.replace(/,/g, '.');
    if (/^[-+]?\d*.?\d*$/.test(newAlerta.pre_ref)) {
      alertas[this.state.tab] = newAlerta;
      this.setState({
        alertas
      });
    }
  } */

  changeOptTemp(event: Object, value): void {
    const alertas = _.cloneDeep(this.state.alertas),
      newAlerta = alertas[this.state.tab];

    if (newAlerta.temp_opt !== value) {
      newAlerta.temp_opt = value;
      alertas[this.state.tab] = newAlerta;

      this.setState({ alertas });
    }
  }

  changeOptHum(event: Object, value): void {
    const alertas = _.cloneDeep(this.state.alertas),
      newAlerta = alertas[this.state.tab];

    if (newAlerta.hum_opt !== value) {
      newAlerta.hum_opt = value;
      alertas[this.state.tab] = newAlerta;

      this.setState({ alertas });
    }
  }

  changeEstado(event: Object, value: boolean): void {
    const alertas = _.cloneDeep(this.state.alertas),
      newAlerta = alertas[this.state.tab];

    if (newAlerta.estado !== value) {
      newAlerta.estado = value;
      alertas[this.state.tab] = newAlerta;

      this.setState({ alertas });
    }
  }

  renderOpts(name: string, value: string = "mayor", changeOpt) {
    return (
      <RadioButtonGroup
        name={name}
        valueSelected={value}
        style={{
          flexDirection: "row",
          display: "inline-flex",
          paddingLeft: 10,
        }}
        onChange={changeOpt}
      >
        <RadioButton
          value="mayor"
          label=">"
          style={{ width: "50%", marginRight: 10 }}
          labelStyle={{ fontWeight: "bold" }}
        />
        <RadioButton
          value="menor"
          label="<"
          style={{ width: "50%" }}
          labelStyle={{ fontWeight: "bold" }}
        />
      </RadioButtonGroup>
    );
  }

  renderTabs() {
    const myAlerts = this.state.alertas.pop();
    return _.map(myAlerts, (alerta, key) => {
      const { nombre, email, estado, temp_ref, temp_opt, hum_ref, hum_opt } =
        alerta;
      /* pre_ref = pre_ref === null || pre_ref === undefined ? 0 : pre_ref;
      pre_opt = pre_opt === null || pre_opt === undefined ? 'mayor' : pre_opt;
      rad_global_ref = rad_global_ref === null || rad_global_ref === undefined ? 0 : rad_global_ref;
      rad_global_opt = rad_global_opt === null || rad_global_opt === undefined ? 'mayor' : rad_global_opt;
      rad_directa_ref = rad_directa_ref === null || rad_directa_ref === undefined ? 0 : rad_directa_ref;
      rad_directa_opt = rad_directa_opt === null || rad_directa_opt === undefined ? 'mayor' : rad_directa_opt; */
      return (
        // <Tab label={nombre} key={key} value={key} style={{ width: '100%', color: 'white' }}>
        <div key={key} style={{ width: "100%", padding: 20 }}>
          <table
            style={{ textAlign: "right", width: "100%" }}
            border="0"
            cellPadding="4"
            cellSpacing="1"
          >
            <tbody>
              <tr>
                <td className="sensor_alerta_title">
                  <b>Nombre de la alerta</b>
                </td>
                <td className="sensor_alerta_info">
                  <input
                    className="sensor_input"
                    type="text"
                    id="sensor-nombre"
                    size="25"
                    value={nombre}
                    onChange={this.changeNombre}
                  />
                </td>
                <td className="sensor_alerta_error">
                  <span style={{ color: "red" }}>
                    {this.state.nombre_error}
                  </span>
                </td>
              </tr>
              <tr>
                <td className="sensor_alerta_title">
                  <b>Email</b>
                </td>
                <td className="sensor_alerta_info">
                  <input
                    className="sensor_input"
                    type="email"
                    id="sensor-email"
                    size="25"
                    value={email}
                    onChange={this.changeEmail}
                  />
                </td>
                <td className="sensor_alerta_error">
                  <span style={{ color: "red" }}>{this.state.email_error}</span>
                </td>
              </tr>
              <tr>
                <td className="sensor_alerta_title">
                  <b>Temperatura de alerta (°C)</b>
                </td>
                <td className="sensor_alerta_info">
                  <input
                    className="sensor_input"
                    type="text"
                    id="sensor-temp"
                    size="9"
                    value={temp_ref}
                    onChange={this.changeTemp}
                    onKeyPress={this.validateNumber}
                  />
                  {this.renderOpts(
                    "sensor-temp-opt",
                    temp_opt,
                    this.changeOptTemp
                  )}
                </td>
                <td className="sensor_alerta_error">
                  <span style={{ color: "red" }}>{this.state.temp_error}</span>
                </td>
                {/* <td className='sensor_alerta_title'><b>Radiación Global (%)</b></td>
                  <td className='sensor_alerta_info'>
                    <input className="sensor_input" type="text" id="sensor-rad_global" size="9" value={rad_global_ref} onChange={this.changeRadGlobal} onKeyPress={this.validateNumber} />
                    {this.renderOpts("sensor-rad_global-opt", rad_global_opt)}
                  </td> */}
              </tr>
              <tr>
                <td className="sensor_alerta_title">
                  <b>Humedad relativa de alerta (%)</b>
                </td>
                <td className="sensor_alerta_info">
                  <input
                    className="sensor_input"
                    type="text"
                    id="sensor-hum"
                    size="9"
                    value={hum_ref}
                    onChange={this.changeHum}
                    onKeyPress={this.validateNumber}
                  />
                  {this.renderOpts(
                    "sensor-hum-opt",
                    hum_opt,
                    this.changeOptHum
                  )}
                </td>
                <td className="sensor_alerta_error">
                  <span style={{ color: "red" }}>{this.state.hum_error}</span>
                </td>
                {/* <td className='sensor_alerta_title'><b>Radiación Directa (%)</b></td>
                  <td className='sensor_alerta_info'>
                    <input className="sensor_input" type="text" id="sensor-rad_directa" size="9" value={rad_directa_ref} onChange={this.changeRadDirecta} onKeyPress={this.validateNumber} />
                    {this.renderOpts("sensor-rad_directa-opt", rad_directa_opt)}
                  </td> */}
              </tr>
              <tr>
                {/* <td className='sensor_alerta_title'><b>Precipitaciones (%)</b></td>
                  <td className='sensor_alerta_info'>
                    <input className="sensor_input" type="text" id="sensor-pre" size="9" value={pre_ref}  onChange={this.changeRadPre} onKeyPress={this.validateNumber} />
                    {this.renderOpts("sensor-pre-opt", pre_opt)}
                  </td> */}
                <td className="sensor_alerta_title">
                  <b>Activo</b>
                </td>
                <td colSpan="2" className="sensor_alerta_info">
                  <Toggle
                    toggled={estado}
                    labelPosition="right"
                    onToggle={this.changeEstado}
                    // style={styles.toggle}
                  />
                </td>
              </tr>
              <tr>
                <td
                  colSpan="3"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    paddingTop: 10,
                    paddingBottom: 10,
                  }}
                >
                  <b>{this.state.msg}</b>
                </td>
              </tr>
              <tr>
                <td colSpan="3" style={{ width: "100%", textAlign: "center" }}>
                  <FlatButton
                    label="Guardar"
                    primary={true}
                    onClick={this.save}
                    backgroundColor="#357bb8"
                    hoverColor="#1e5d92"
                    labelStyle={{ color: "white" }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        // </Tab>
      );
    });
  }

  render() {
    return (
      <div style={{ width: "100%" }}>
        <Tabs
          style={{ width: "100%" }}
          onChange={this.changeTab}
          value={this.state.tab}
        >
          {_.map(this.state.alertas, (alerta, key) => {
            const { nombre } = alerta;
            return (
              <Tab
                label={nombre}
                key={key}
                value={key}
                style={{ width: "100%", color: "white" }}
              />
            );
          })}
        </Tabs>

        <SwipeableViews
          style={{ width: "100%" }}
          index={this.state.tab}
          onChangeIndex={this.changeTab}
        >
          {this.renderTabs()}
        </SwipeableViews>
      </div>
    );
  }
}

type T_DialogSensorProps = {
  window_drag: boolean,
  sen: T_Sen,
  app: App,
  toolbar: Toolbar,
  width: number,
  height: number,
  email: string,
};

export type T_Info = {
  temp: number,
  hum: number,
  pre: number,
  rad_global: number,
  rad_directa: number,
  wind_speed?: number,
  wind_deg?: number,
  clouds?: number,
  dpv: number,
  mh: number,
  fecha: string,
};

type T_Rad = {
  value: number,
  rad_fecha: string,
  fecha: string,
};

type T_DPV = {
  value: number,
  fecha: string,
};

type T_MH = {
  value: number,
  fecha: string,
};

type T_Prueba = {
  radPrueba: number,
  evaPrueba: number,
  fecha: string,
};

type T_Data = {
  mh: Array<T_MH>,
  dpv: Array<T_DPV>,
  info: Array<T_Info>,
  info_ant: Array<T_Info>,
  rad_global: Array<T_Rad>,
  rad_directa: Array<T_Rad>,
  diaria: Object,
  prueba: Array<T_Prueba>,
  data_diaria: Array<Object>,
};

type T_DialogSensorState = {
  sen: T_Sen,
  lat: number,
  lng: number,
  data: T_Data,
  alerta: T_SenAlerta,
  alertas: Array<T_SenAlerta>,
  isLoading: boolean,
  titulo_error: string,
  visible: boolean,
  forecast: any,
  current: any,
  location: any,
  sumatoria: number,
  fecha: any,
  sumaFrio: string,
  fechaFrio: string,
  sumaDiez: string,
  fechaDiez: string,
  from: string,
  to: string,
  show: boolean,
  exportData: Array<any>,
  exportDataResumen: Array<any>,
  sumaGDias: number,
};

export default class DialogSensor extends Component<
  T_DialogSensorProps,
  T_DialogSensorState
> {
  close: () => void;
  sumaGradoDiez: () => void;
  downloadExcel: () => void;
  downloadExcelDiario: () => void;
  changeTitulo: (ev: SyntheticInputEvent<*>) => void;
  getBalloonTextViento: (data: Object, graph: Object) => string;

  marker: ?Object;
  alertaEmpty: T_SenAlerta;
  Tabs: Tabs;

  constructor(props: T_DialogSensorProps) {
    super(props);

    this.alertaEmpty = {
      id: 0,
      nombre: "Alerta ",
      email: "",
      temp_ref: 0,
      temp_opt: "mayor",
      hum_ref: 0,
      hum_opt: "mayor",
      /* pre_ref         : 0,
      pre_opt         : 'mayor',
      rad_global_ref  : 0,
      rad_global_opt  : 'mayor',
      rad_directa_ref : 0,
      rad_directa_opt : 'mayor', */
      estado: false,
    };

    this.state = {
      sen: this.props.sen,
      lat: this.props.sen.lat,
      lng: this.props.sen.lng,
      data: {
        mh: [],
        dpv: [],
        info: [],
        info_ant: [],
        rad_global: [],
        rad_directa: [],
        diaria: {},
        diaria_ant: {},
        prueba: [],
        data_diaria: [],
        data_diaria_ant: [],
      },
      alerta: this.alertaEmpty,
      alertas: [
        {
          id: -1,
          nombre: "",
          email: "",
          temp_ref: 0,
          temp_opt: "",
          hum_ref: 0,
          hum_opt: "",
          estado: false,
        },
        {
          id: -1,
          nombre: "",
          email: "",
          temp_ref: 0,
          temp_opt: "",
          hum_ref: 0,
          hum_opt: "",
          estado: false,
        },
        {
          id: -1,
          nombre: "",
          email: "",
          temp_ref: 0,
          temp_opt: "",
          hum_ref: 0,
          hum_opt: "",
          estado: false,
        },
      ],
      isLoading: true,
      titulo_error: "",
      visible: true,
      forecast: [],
      current: [],
      location: "",
      sumatoria: 0,
      fecha: "",
      alertaFito: false,
      alertaHelada: false,
      from: moment().subtract(1, "months").format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
      show: false,
      exportData: [],
      exportDataResumen: [],
      sumaGDias: 0,
    };

    this.close = this.close.bind(this);
    this.changeTitulo = this.changeTitulo.bind(this);
    this.sumaGradoDiez = this.sumaGradoDiez.bind(this);
    this.downloadExcel = this.downloadExcel.bind(this);
    this.downloadExcelDiario = this.downloadExcelDiario.bind(this);
    this.getBalloonTextViento = this.getBalloonTextViento.bind(this);

    // this.getTodayWeather      = this.getTodayWeather.bind(this);
    // this.getForecasting       = this.getForecasting.bind(this);

    this.props.app.dialog_sensor = this;
  }

  snum(num: number): string {
    if (num) {
      return num.toFixed(this.props.app.state.num_decimals);
    } else {
      return "";
    }
  }

  async set_graph(sen: T_Sen): Promise<void> {
    if (sen.file !== "") {
      const { app } = this.props,
        url = `${app.remote}/get-sensor/?path=${sen.path}&uuid=${
          sen.uuid
        }&session_id=${app.session()}`;
      const res = await (await fetch(url)).json();

      // const empty_alerta = {
      //   id: -1,
      //   nombre: '',
      //   email: '',
      //   temp_ref: 0,
      //   temp_opt: '',
      //   hum_ref: 0,
      //   hum_opt: '',
      //   estado: false,
      // };

      if (res.error && typeof res.error === "string") {
        Alert.error(res.error, { position: "bottom-left" });
      } else {
        if (res.error) {
          Alert.error(res.error, { position: "bottom-left" });

          await this.setState({
            isLoading: false,
          });
        } else {
          const rads_global = [],
            rads_directa = [],
            dpvs = [],
            mhs = [];

          const infos = _.map(res.data, (info) => {
            const fecha = new Date(info.fecha),
              pre = info.pre ? info.pre : 0,
              rad_fecha = info.rad_fecha ? new Date(info.rad_fecha) : "",
              rad_global = info.rad_global ? info.rad_global : 0,
              rad_directa = info.rad_directa ? info.rad_directa : 0,
              wind_speed = info.wind_speed ? info.wind_speed : 0,
              wind_deg = info.wind_deg ? info.wind_deg : 0,
              clouds = info.clouds ? info.clouds : 0,
              dpv = info.dpv ? info.dpv : 0,
              mh = info.mh ? info.mh : 0,
              fecha_short = `${fecha.getFullYear()}-${
                fecha.getMonth() + 1
              }-${fecha.getDate()}`;

            rads_global.push({
              value: rad_global,
              rad_fecha,
              fecha,
            });

            rads_directa.push({
              value: rad_directa,
              rad_fecha,
              fecha,
            });

            dpvs.push({
              value: dpv,
              fecha,
            });

            mhs.push({
              value: mh,
              fecha,
            });

            const the_info = {
              temp: info.temp,
              hum: info.hum,
              pre,
              rad_global,
              rad_directa,
              fecha,
              wind_speed,
              wind_deg,
              clouds,
              dpv,
              mh,
              fecha_short,
            };

            /* if (info.wind_speed) { the_info.wind_speed = info.wind_speed; } else { delete the_info.wind_speed; }
            if (info.wind_deg  ) { the_info.wind_deg   = info.wind_deg  ; } else { delete the_info.wind_deg  ; }
            if (info.clouds    ) { the_info.clouds     = info.clouds    ; } else { delete the_info.clouds    ; } */

            return the_info;
          });

          const infos_ant =
            res.data_ant.length === 0
              ? []
              : _.map(res.data_ant, (info) => {
                  const fecha = new Date(info.fecha),
                    pre = info.pre ? info.pre : 0,
                    rad_fecha = info.rad_fecha ? new Date(info.rad_fecha) : "",
                    rad_global = info.rad_global ? info.rad_global : 0,
                    rad_directa = info.rad_directa ? info.rad_directa : 0,
                    wind_speed = info.wind_speed ? info.wind_speed : 0,
                    wind_deg = info.wind_deg ? info.wind_deg : 0,
                    clouds = info.clouds ? info.clouds : 0,
                    dpv = info.dpv ? info.dpv : 0,
                    mh = info.mh ? info.mh : 0,
                    fecha_short = `${fecha.getFullYear()}-${
                      fecha.getMonth() + 1
                    }-${fecha.getDate()}`;

                  rads_global.push({
                    value: rad_global,
                    rad_fecha,
                    fecha,
                  });

                  rads_directa.push({
                    value: rad_directa,
                    rad_fecha,
                    fecha,
                  });

                  dpvs.push({
                    value: dpv,
                    fecha,
                  });

                  mhs.push({
                    value: mh,
                    fecha,
                  });

                  const the_info = {
                    temp: info.temp,
                    hum: info.hum,
                    pre,
                    rad_global,
                    rad_directa,
                    fecha,
                    wind_speed,
                    wind_deg,
                    clouds,
                    dpv,
                    mh,
                    fecha_short,
                  };

                  return the_info;
                });

          const maxs = [],
            mins = [],
            gdiez = [],
            evapo = [],
            maxs_ant = [],
            mins_ant = [],
            gdiez_ant = [],
            evapo_ant = [];
          _.map(res.diaria, (info) => {
            const fecha = new Date(info.fecha);

            maxs.push({ temps: info.temp_max, fecha });
            mins.push({ temps: info.temp_min, fecha });
            gdiez.push({ temps: info.grado_diez, fecha });
            evapo.push({
              evapo_abs: info.evapotrans,
              evapo: parseFloat(info.evapotrans) * -1,
              fecha,
            });

            info.temp_prom = parseFloat(
              (parseFloat(info.temp_min) + parseFloat(info.temp_max)) / 2
            ).toFixed(2);
            info.fecha = fecha;

            const diaria_ant = res.diaria_ant.filter(
              (item) => item.mes_dia === info.mes_dia
            );

            // Periodo anterior sensor_data_diaria
            if (diaria_ant.length) {
              info.temp_max_ant = diaria_ant[0].temp_max;
              info.temp_min_ant = diaria_ant[0].temp_min;
              info.grado_diez_ant = diaria_ant[0].grado_diez;
              info.evapotrans_ant = diaria_ant[0].evapotrans;
              info.temp_prom_ant = parseFloat(
                (parseFloat(diaria_ant[0].temp_min) +
                  parseFloat(diaria_ant[0].temp_max)) /
                  2
              ).toFixed(2);
            } else {
              info.temp_max_ant = null;
              info.temp_min_ant = null;
              info.grado_diez_ant = null;
              info.evapotrans_ant = null;
              info.temp_prom_ant = null;
            }

            // Periodo actual sensor_data agegado por dia
            const diaria_hora = res.diaria_hora.filter(
              (item) => item.mes_dia === info.mes_dia
            );

            if (diaria_hora.length) {
              info.pre = diaria_hora[0].pre;
              info.hum_prom = parseFloat(diaria_hora[0].hum_prom).toFixed(0);
              info.hum_min = parseFloat(diaria_hora[0].hum_min).toFixed(0);
              info.hum_max = parseFloat(diaria_hora[0].hum_max).toFixed(0);
            } else {
              info.pre = null;
              info.hum_prom = null;
              info.hum_min = null;
              info.hum_max = null;
            }

            // Periodo anterior sensor_data agregado por dia
            const diaria_hora_ant = res.diaria_hora_ant.filter(
              (item) => item.mes_dia === info.mes_dia
            );

            if (diaria_hora_ant.length) {
              info.pre_ant = diaria_hora_ant[0].pre;
              info.hum_prom_ant = parseFloat(
                diaria_hora_ant[0].hum_prom
              ).toFixed(0);
              info.hum_min_ant = parseFloat(diaria_hora_ant[0].hum_min).toFixed(
                0
              );
              info.hum_max_ant = parseFloat(diaria_hora_ant[0].hum_max).toFixed(
                0
              );
            } else {
              info.pre_ant = null;
              info.hum_prom_ant = null;
              info.hum_min_ant = null;
              info.hum_max_ant = null;
            }
          });

          _.map(res.diaria_ant, (info) => {
            const fecha = new Date(info.fecha);

            maxs_ant.push({ temps: info.temp_max, fecha });
            mins_ant.push({ temps: info.temp_min, fecha });
            gdiez_ant.push({ temps: info.grado_diez, fecha });
            evapo_ant.push({
              evapo_abs: info.evapotrans,
              evapo: parseFloat(info.evapotrans) * -1,
              fecha,
            });

            info.temp_prom = parseFloat(
              (parseFloat(info.temp_min) + parseFloat(info.temp_max)) / 2
            ).toFixed(2);
            info.fecha = fecha;

            const diaria_hora_ant = res.diaria_hora_ant;

            if (diaria_hora_ant.length) {
              info.pre_ant = diaria_hora_ant[0].pre;
              info.hum_prom_ant = parseFloat(
                diaria_hora_ant[0].hum_prom
              ).toFixed(0);
              info.hum_min_ant = parseFloat(diaria_hora_ant[0].hum_min).toFixed(
                0
              );
              info.hum_max_ant = parseFloat(diaria_hora_ant[0].hum_max).toFixed(
                0
              );
            } else {
              info.pre_ant = null;
              info.hum_prom_ant = null;
              info.hum_min_ant = null;
              info.hum_max_ant = null;
            }
          });

          // ESTO ES PARA UN UNICO SENSOR Y ES PARA COMPARAR LA DATA UUID = 93c17020-2876-11e8-ba00-dfdffa262303
          // let prueba = { rad: [], eva: [] };
          let prueba = [];

          if (
            sen.uuid === "93c17020-2876-11e8-ba00-dfdffa262303" &&
            res.prueba
          ) {
            prueba = _.map(res.prueba, (info) => {
              const fecha = new Date(info.fecha);
              return { radPrueba: info.rad, evaPrueba: info.eva_pot, fecha };
            });
          }

          // const alertas = _.map(sen.alertas, (alerta, key) => {
          //   if (alerta !== null) {
          //     const { estado, temp_ref, temp_opt, hum_ref, hum_opt } = alerta;

          //     /* pre_ref = pre_ref === null || pre_ref === undefined ? 0 : pre_ref;
          //     pre_opt = pre_opt === null || pre_opt === undefined ? 'mayor' : pre_opt;
          //     rad_global_ref = rad_global_ref === null || rad_global_ref === undefined ? 0 : rad_global_ref;
          //     rad_global_opt = rad_global_opt === null || rad_global_opt === undefined ? 'mayor' : rad_global_opt;
          //     rad_directa_ref = rad_directa_ref === null || rad_directa_ref === undefined ? 0 : rad_directa_ref;
          //     rad_directa_opt = rad_directa_opt === null || rad_directa_opt === undefined ? 'mayor' : rad_directa_opt; */

          //     alerta.estado = estado === 1 ? true : estado === 0 ? false : estado;
          //     alerta.temp_ref = temp_ref === null || temp_ref === undefined ? 0 : temp_ref;
          //     alerta.temp_opt = temp_opt === null || temp_opt === undefined ? 'mayor' : temp_opt;
          //     alerta.hum_ref = hum_ref === null || hum_ref === undefined ? 0 : hum_ref;
          //     alerta.hum_opt = hum_opt === null || hum_opt === undefined ? 'mayor' : hum_opt;
          //     return alerta;
          //   } else {
          //     return {
          //       id      :    -1,
          //       nombre  :    '',
          //       email   :    '',
          //       temp_ref:     0,
          //       temp_opt:    '',
          //       hum_ref :     0,
          //       hum_opt :    '',
          //       estado  : false
          //     }
          //   }
          // });

          if (sen.alertas.length <= 1) {
            let alertas = _.map(sen.alertas, (alerta, key) => {
              if (alerta !== null) {
                const { estado, temp_ref, temp_opt, hum_ref, hum_opt } = alerta;

                /* pre_ref = pre_ref === null || pre_ref === undefined ? 0 : pre_ref;
                pre_opt = pre_opt === null || pre_opt === undefined ? 'mayor' : pre_opt;
                rad_global_ref = rad_global_ref === null || rad_global_ref === undefined ? 0 : rad_global_ref;
                rad_global_opt = rad_global_opt === null || rad_global_opt === undefined ? 'mayor' : rad_global_opt;
                rad_directa_ref = rad_directa_ref === null || rad_directa_ref === undefined ? 0 : rad_directa_ref;
                rad_directa_opt = rad_directa_opt === null || rad_directa_opt === undefined ? 'mayor' : rad_directa_opt; */

                alerta.estado =
                  estado === 1 ? true : estado === 0 ? false : estado;
                alerta.temp_ref =
                  temp_ref === null || temp_ref === undefined ? 0 : temp_ref;
                alerta.temp_opt =
                  temp_opt === null || temp_opt === undefined
                    ? "mayor"
                    : temp_opt;
                alerta.hum_ref =
                  hum_ref === null || hum_ref === undefined ? 0 : hum_ref;
                alerta.hum_opt =
                  hum_opt === null || hum_opt === undefined ? "mayor" : hum_opt;

                return alerta;
              } else {
                return {
                  id: -1,
                  nombre: "",
                  email: "",
                  temp_ref: 0,
                  temp_opt: "",
                  hum_ref: 0,
                  hum_opt: "",
                  estado: false,
                };
              }
            });

            for (let ind = sen.alertas.length + 1; ind < 3; ind++) {
              const alertaEmpty = _.cloneDeep(this.alertaEmpty);
              alertaEmpty.id = -1;
              alertas.push(alertaEmpty);
            }

            await this.setState({
              data: {
                mh: _.sortBy(mhs, ["fecha"]),
                dpv: _.sortBy(dpvs, ["fecha"]),
                info: _.sortBy(infos, ["fecha"]),
                info_ant: _.sortBy(infos_ant, ["fecha"]),
                rad_global: _.sortBy(rads_global, ["fecha"]),
                rad_directa: _.sortBy(rads_directa, ["fecha"]),
                diaria: {
                  maxs: _.sortBy(maxs, ["fecha"]),
                  mins: _.sortBy(mins, ["fecha"]),
                  gdiez: _.sortBy(gdiez, ["fecha"]),
                  evapo: _.sortBy(evapo, ["fecha"]),
                },
                diaria_ant: {
                  maxs: _.sortBy(maxs_ant, ["fecha"]),
                  mins: _.sortBy(mins_ant, ["fecha"]),
                  gdiez: _.sortBy(gdiez_ant, ["fecha"]),
                  evapo: _.sortBy(evapo_ant, ["fecha"]),
                },
                prueba,
                data_diaria: res.diaria,
                data_diaria_ant: res.diaria_ant,
              },
              alertas,
              alerta: alertas[0],
              isLoading: false,
              sumaFrio: (res.frio && res.frio.suma_frio) || "",
              fechaFrio: (res.frio && res.frio.fecha_frio) || "",
              sumaDiez: (res.diez && res.diez.suma_diez) || "",
              fechaDiez: (res.diez && res.diez.fecha_diez) || "",
            });

            await this.check_alertas(this.state.sen);
          } else {
            const alertas = _.map(sen.alertas, (alerta, key) => {
              if (alerta !== null) {
                const { estado, temp_ref, temp_opt, hum_ref, hum_opt } = alerta;

                /* pre_ref = pre_ref === null || pre_ref === undefined ? 0 : pre_ref;
                pre_opt = pre_opt === null || pre_opt === undefined ? 'mayor' : pre_opt;
                rad_global_ref = rad_global_ref === null || rad_global_ref === undefined ? 0 : rad_global_ref;
                rad_global_opt = rad_global_opt === null || rad_global_opt === undefined ? 'mayor' : rad_global_opt;
                rad_directa_ref = rad_directa_ref === null || rad_directa_ref === undefined ? 0 : rad_directa_ref;
                rad_directa_opt = rad_directa_opt === null || rad_directa_opt === undefined ? 'mayor' : rad_directa_opt; */

                alerta.estado =
                  estado === 1 ? true : estado === 0 ? false : estado;
                alerta.temp_ref =
                  temp_ref === null || temp_ref === undefined ? 0 : temp_ref;
                alerta.temp_opt =
                  temp_opt === null || temp_opt === undefined
                    ? "mayor"
                    : temp_opt;
                alerta.hum_ref =
                  hum_ref === null || hum_ref === undefined ? 0 : hum_ref;
                alerta.hum_opt =
                  hum_opt === null || hum_opt === undefined ? "mayor" : hum_opt;
                return alerta;
              } else {
                return {
                  id: -1,
                  nombre: "",
                  email: "",
                  temp_ref: 0,
                  temp_opt: "",
                  hum_ref: 0,
                  hum_opt: "",
                  estado: false,
                };
              }
            });

            await this.setState({
              data: {
                mh: _.sortBy(mhs, ["fecha"]),
                dpv: _.sortBy(dpvs, ["fecha"]),
                info: _.sortBy(infos, ["fecha"]),
                info_ant: _.sortBy(infos_ant, ["fecha"]),
                rad_global: _.sortBy(rads_global, ["fecha"]),
                rad_directa: _.sortBy(rads_directa, ["fecha"]),
                diaria: {
                  maxs: _.sortBy(maxs, ["fecha"]),
                  mins: _.sortBy(mins, ["fecha"]),
                  gdiez: _.sortBy(gdiez, ["fecha"]),
                  evapo: _.sortBy(evapo, ["fecha"]),
                },
                prueba,
                data_diaria: res.diaria,
                data_diaria_ant: res.diaria_ant,
              },
              alertas,
              alerta: alertas[0],
              isLoading: false,
              sumaFrio: (res.frio && res.frio.suma_frio) || "",
              fechaFrio: (res.frio && res.frio.fecha_frio) || "",
              sumaDiez: (res.diez && res.diez.suma_diez) || "",
              fechaDiez: (res.diez && res.diez.fecha_diez) || "",
            });

            await this.check_alertas(this.state.sen);
          }

          // for (let ind = sen.alertas.length + 1; ind < 4; ind++) {
          //   const alertaEmpty = _.cloneDeep(this.alertaEmpty);

          //   alertaEmpty.id      = ind - 100;
          //   alertaEmpty.nombre += ind;

          //   alertas.push(alertaEmpty);
          // }
          // await this.setState({
          //   data: {
          //     info       : _.sortBy(infos, ['fecha']),
          //     rad_global : _.sortBy(rads_global, ['fecha']),
          //     rad_directa: _.sortBy(rads_directa, ['fecha']),
          //     diaria: {
          //       maxs : _.sortBy(maxs, ['fecha']),
          //       mins : _.sortBy(mins, ['fecha']),
          //       gdiez: _.sortBy(gdiez, ['fecha']),
          //       evapo: _.sortBy(evapo, ['fecha']),
          //     },
          //     prueba,
          //     data_diaria: res.diaria
          //   },
          //   alertas,
          //   alerta   : alertas[0],
          //   isLoading: false,
          //   sumaFrio: (res.frio && res.frio.suma_frio) || '',
          //   fechaFrio: (res.frio && res.frio.fecha_frio) || '',
          //   sumaDiez: (res.diez && res.diez.suma_diez) || '',
          //   fechaDiez: (res.diez && res.diez.fecha_diez) || ''
          // });
        }
      }

      /* fetch(url).then(resp => resp.json()).then((res) => {
        
      }); */
    } else {
      const alertas = sen.alertas;

      alertas.forEach((alerta, i) => {
        const { sen } = this.state,
          empty_alerta = {
            id: -1,
            nombre: "",
            email: "",
            temp_ref: 0,
            temp_opt: "",
            hum_ref: 0,
            hum_opt: "",
            estado: false,
          };
        if (alerta === null) {
          this.setState((sen.alertas[i] = empty_alerta));
        } else if (sen.alertas.length <= 1) {
          sen.alertas.push(empty_alerta);
        }
      });

      this.setState({
        alertas,
        alerta: alertas[0],
        isLoading: false,
      });

      await this.check_alertas(this.state.sen);
    }
  }

  componentWillUnmount() {
    if (this.marker != null) {
      this.marker.setMap(null);
    }

    this.props.app.dialog_sensor = null;
  }

  async componentWillReceiveProps(newProps: T_DialogSensorProps) {
    const { sen } = this.state;

    // se cambio de sensor o se creo uno nuevo
    if (
      sen.uuid !== newProps.sen.uuid ||
      sen.file !== newProps.sen.file ||
      sen.id !== newProps.sen.id
    ) {
      await this.setState({
        sen: newProps.sen,
        lat: newProps.sen.lat,
        lng: newProps.sen.lng,
        data: {
          mh: [],
          dpv: [],
          info: [],
          info_ant: [],
          rad_global: [],
          rad_directa: [],
          diaria: {},
          diaria_ant: {},
          prueba: [],
          data_diaria: [],
          data_diaria_ant: [],
        },
        alertas: [
          {
            id: -1,
            nombre: "",
            email: "",
            temp_ref: 0,
            temp_opt: "",
            hum_ref: 0,
            hum_opt: "",
            estado: false,
          },
          {
            id: -1,
            nombre: "",
            email: "",
            temp_ref: 0,
            temp_opt: "",
            hum_ref: 0,
            hum_opt: "",
            estado: false,
          },
          {
            id: -1,
            nombre: "",
            email: "",
            temp_ref: 0,
            temp_opt: "",
            hum_ref: 0,
            hum_opt: "",
            estado: false,
          },
        ],
        alerta: this.alertaEmpty,
        isLoading: true,
        titulo_error: "",
        visible: true,
      });

      await this.set_graph(newProps.sen);
      this.set_marker();
    } else if (
      sen.uuid === newProps.sen.uuid &&
      sen.alertas !== newProps.sen.alertas
    ) {
      // si solo cambiaron las alertas
      const alertas = _.map(newProps.sen.alertas, (alerta, key) => {
        const { estado, temp_ref, temp_opt, hum_ref, hum_opt } = alerta;

        /* pre_ref = pre_ref === null || pre_ref === undefined ? 0 : pre_ref;
        pre_opt = pre_opt === null || pre_opt === undefined ? 'mayor' : pre_opt;
        rad_global_ref = rad_global_ref === null || rad_global_ref === undefined ? 0 : rad_global_ref;
        rad_global_opt = rad_global_opt === null || rad_global_opt === undefined ? 'mayor' : rad_global_opt;
        rad_directa_ref = rad_directa_ref === null || rad_directa_ref === undefined ? 0 : rad_directa_ref;
        rad_directa_opt = rad_directa_opt === null || rad_directa_opt === undefined ? 'mayor' : rad_directa_opt; */

        alerta.estado = estado === 1 ? true : estado === 0 ? false : estado;
        alerta.temp_ref =
          temp_ref === null || temp_ref === undefined ? 0 : temp_ref;
        alerta.temp_opt =
          temp_opt === null || temp_opt === undefined ? "mayor" : temp_opt;
        alerta.hum_ref =
          hum_ref === null || hum_ref === undefined ? 0 : hum_ref;
        alerta.hum_opt =
          hum_opt === null || hum_opt === undefined ? "mayor" : hum_opt;
        return alerta;
      });

      for (let ind = newProps.sen.alertas.length + 1; ind < 3; ind++) {
        const alertaEmpty = _.cloneDeep(this.alertaEmpty);
        alertaEmpty.id = -1;
        alertas.push(alertaEmpty);
      }

      await this.setState({
        sen: newProps.sen,
        alertas,
        // alerta: alertas[this.Tabs.state.tab],
        isLoading: true,
        titulo_error: "",
      });

      await this.check_alertas(this.state.sen);
    }
  }

  set_marker() {
    if (this.marker != null) {
      this.marker.setMap(null);
      this.marker = null;
    }

    if (Map.google != null && this.marker == null) {
      const google_lib = Map.google;

      this.marker = new google_lib.Marker({
        position: {
          lat: parseFloat(this.state.lat),
          lng: parseFloat(this.state.lng),
        },
        map: this.props.app.map_ui.map.map,
        draggable: this.state.sen.file === "",
        title: this.state.sen.titulo ? this.state.sen.titulo : "Sensor",
        icon: "img/icono_sensor2.gif",
      });

      this.marker.setMap(this.props.app.map_ui.map.map);

      google_lib.event.addListener(this.marker, "click", () => {
        this.setState({ visible: true });
      });

      if (this.state.sen.file === "") {
        google_lib.event.addListener(this.marker, "dragend", (ev) => {
          this.setState({
            lat: ev.latLng.lat(),
            lng: ev.latLng.lng(),
          });
        });
      }
    }
  }

  close(): void {
    /* if (this.props.app.state.sen != null) {
      const item_sen = this.props.app.get_item_sen(this.props.app.state.sen.path);

      if (item_sen != null) {
        item_sen.close();
      }
    }
    
    this.props.app.setState({sen: null}); */

    this.setState({ visible: false });
  }

  changeTitulo(ev: SyntheticInputEvent<*>): void {
    const sen = _.cloneDeep(this.state.sen);

    sen.titulo = ev.target.value;

    this.setState({
      sen,
      titulo_error: "",
    });
  }

  get_date(str: string): Date {
    const [dd, mm, yy, hh] = _.initial(
      _.flatten(
        _.flatten(str.split("-").map((ss) => ss.split(" "))).map((ss) =>
          ss.split(":")
        )
      )
    ).map((ss) => parseInt(ss, 10));

    return new Date(yy, mm - 1, dd, hh);
  }

  sumaGradoDiez(): void {
    const startDate = this.get_date(
        $(".amChartsInputField.amcharts-start-date-input").val()
      ).getTime(),
      endDate = this.get_date(
        $(".amChartsInputField.amcharts-end-date-input").val()
      ).getTime(),
      grado_diez = this.state.data.diaria.gdiez
        ? this.state.data.diaria.gdiez
        : [],
      filtrado = _.filter(grado_diez, (gd) => {
        const fecha = new Date(gd.fecha).getTime();

        return startDate <= fecha && fecha <= endDate;
      }),
      suma = _.sumBy(filtrado, "temps");

    $("#suma_grado_diez").html(
      `<b>Sumatoria de ° Días base 10:</b> ${this.snum(suma)}`
    );
  }

  handleFiltrar(e): void {
    e.preventDefault();

    if (!this.state.from || !this.state.to) {
      alert(
        "Por favor indicar periodo de fechas para generar reporte de Climasense"
      );
      return false;
    }

    this.newFiltrarDatos();
    this.newFiltrarDatosResumen();
  }

  newFiltrarDatos() {
    const startDate = new Date(this.state.from).getTime();
    const endDate = new Date(this.state.to).getTime();

    const search = (info) => {
      const fecha = new Date(info.fecha).getTime();
      return startDate <= fecha && fecha <= endDate + 86400000; // Se le suma un dia en milisegundos para que aparezca ese dia en la tabla
    };

    const exportData = [];
    const _filteredData = this.state.data.info_ant.concat(this.state.data.info);
    // const filteredData = _.groupBy(
    //   this.state.data.info.filter(search),
    //   'fecha_short'
    // );
    const filteredData = _.groupBy(_filteredData.filter(search), "fecha_short");
    const _filteredDataDiaria = this.state.data.data_diaria_ant.concat(
      this.state.data.data_diaria
    );
    // const filteredDataDiaria = this.state.data.data_diaria.filter(search);
    const filteredDataDiaria = _filteredDataDiaria.filter(search);

    let sumaGDias = 0;
    for (const info of filteredDataDiaria) {
      sumaGDias += info.grado_diez;
    }

    for (const fecha in filteredData) {
      const last = filteredData[fecha].length - 1;

      const filteredDiaria = filteredDataDiaria.filter(
        (item) =>
          fecha ===
          `${item.fecha.getFullYear()}-${
            item.fecha.getMonth() + 1
          }-${item.fecha.getDate()}`
      );

      let index = 0;
      for (const info of filteredData[fecha]) {
        const maxValue =
          index === last && filteredDiaria.length
            ? filteredDiaria[0].temp_max
            : "";
        const minValue =
          index === last && filteredDiaria.length
            ? filteredDiaria[0].temp_min
            : "";
        const gdiezValue =
          index === last && filteredDiaria.length
            ? filteredDiaria[0].grado_diez
            : "";
        const evapoValue =
          index === last && filteredDiaria.length
            ? filteredDiaria[0].evapotrans
            : "";

        exportData.push({
          fecha: moment(info.fecha).format("DD/MM/YYYY HH:mm:ss"),
          temp: info.temp,
          hum: info.hum,
          pre: info.pre,
          rad_global: info.rad_global,
          rad_directa: info.rad_directa,
          wind_speed: !!info.wind_speed
            ? parseFloat(info.wind_speed).toFixed(2)
            : 0,
          wind_deg: !!info.wind_deg ? parseFloat(info.wind_deg).toFixed(2) : 0,
          clouds: !!info.clouds ? parseFloat(info.clouds).toFixed(2) : 0,
          maxs: !!maxValue ? parseFloat(maxValue).toFixed(2) : "",
          mins: !!minValue ? parseFloat(minValue).toFixed(2) : "",
          gdiez: !!gdiezValue ? parseFloat(gdiezValue).toFixed(2) : "",
          evapo: evapoValue,
        });

        index++;
      }
    }

    this.setState({ exportData, sumaGDias });
  }

  newFiltrarDatosResumen() {
    const startDate = new Date(this.state.from).getTime();
    const endDate = new Date(this.state.to).getTime();

    // console.log('startDate: ', startDate, 'endDate: ', endDate);

    const search = (info) => {
      const fecha = new Date(info.fecha).getTime();
      return startDate <= fecha && fecha <= endDate + 86400000;
    };

    const exportDataResumen = [];

    const _filteredData = this.state.data.info_ant.concat(this.state.data.info);
    const filteredData = _.groupBy(_filteredData.filter(search), "fecha_short");

    const _filteredDataDiaria = this.state.data.data_diaria_ant.concat(
      this.state.data.data_diaria
    );
    const filteredDataDiaria = _filteredDataDiaria.filter(search);

    for (const fecha in filteredData) {
      const filteredDiaria = filteredDataDiaria.filter(
        (item) =>
          fecha ===
          `${item.fecha.getFullYear()}-${
            item.fecha.getMonth() + 1
          }-${item.fecha.getDate()}`
      );

      const tempMax = _.maxBy(filteredData[fecha], (fd) => parseFloat(fd.temp)),
        tempMin = _.minBy(filteredData[fecha], (fd) => parseFloat(fd.temp)),
        tempMean = _.meanBy(filteredData[fecha], (fd) => parseFloat(fd.temp)),
        preSum = _.sumBy(filteredData[fecha], (fd) => parseFloat(fd.pre)),
        radGlobalSum = _.sumBy(filteredData[fecha], (fd) => fd.rad_global),
        radDirectaSum = _.sumBy(filteredData[fecha], (fd) => fd.rad_directa),
        windSpeedSum = _.sumBy(filteredData[fecha], (fd) => fd.wind_speed),
        evapoSum =
          filteredDiaria.length > 0
            ? parseFloat(filteredDiaria[0].evapotrans)
            : 0,
        humMean = _.meanBy(filteredData[fecha], (fd) => parseFloat(fd.hum)),
        cloudsMean = _.meanBy(filteredData[fecha], (fd) => fd.clouds),
        gradosDiaSum = _.sumBy(filteredData[fecha], (fd) =>
          parseFloat(fd.temp)
        );
      exportDataResumen.push({
        fecha: fecha,
        tempMax: parseFloat(tempMax.temp),
        tempMin: parseFloat(tempMin.temp),
        tempMean: tempMean,
        preSum: preSum,
        radGlobalSum: radGlobalSum,
        radDirectaSum: radDirectaSum,
        windSpeedSum: windSpeedSum,
        evapoSum: evapoSum,
        humMean: humMean,
        cloudsMean: cloudsMean,
        gradosDiaSum: gradosDiaSum,
      });
    }

    this.setState({ exportDataResumen });
  }

  filtrarDatos(): void {
    const exportData = [];

    const startDate = new Date(this.state.from).getTime(),
      endDate = new Date(this.state.to).getTime(),
      entre_fechas = (info) => {
        const fecha = new Date(info.fecha).getTime();
        return startDate <= fecha && fecha <= endDate;
      },
      filtradoData = _.filter(this.state.data.info, entre_fechas),
      filtardoDiarioMax = _.filter(this.state.data.diaria.maxs, entre_fechas),
      filtardoDiarioMin = _.filter(this.state.data.diaria.mins, entre_fechas),
      filtardoDiarioGbd = _.filter(this.state.data.diaria.gdiez, entre_fechas),
      filtardoDiarioEvp = _.filter(this.state.data.diaria.evapo, entre_fechas),
      sumaGDias = _.sumBy(filtardoDiarioGbd, "temps");

    filtradoData.forEach((dd, kk) => {
      let maxValue = "",
        minValue = "",
        gdiezValue = "",
        evapoValue = "";

      filtardoDiarioMax.forEach((max, key) => {
        const fecha = new Date(max.fecha),
          fechaData = new Date(dd.fecha);

        if (
          fecha.getDate() === fechaData.getDate() &&
          fecha.getMonth() === fechaData.getMonth() &&
          fecha.getHours() >= 23 &&
          fechaData.getHours() >= 23
        ) {
          maxValue = max.temps;
        }
      });

      filtardoDiarioMin.forEach((min, key) => {
        const fecha = new Date(min.fecha),
          fechaData = new Date(dd.fecha);

        if (
          fecha.getDate() === fechaData.getDate() &&
          fecha.getMonth() === fechaData.getMonth() &&
          fecha.getHours() >= 23 &&
          fechaData.getHours() >= 23
        ) {
          minValue = min.temps;
        }
      });

      filtardoDiarioGbd.forEach((gdiez, key) => {
        const fecha = new Date(gdiez.fecha),
          fechaData = new Date(dd.fecha);

        if (
          fecha.getDate() === fechaData.getDate() &&
          fecha.getMonth() === fechaData.getMonth() &&
          fecha.getHours() >= 23 &&
          fechaData.getHours() >= 23
        ) {
          gdiezValue = gdiez.temps;
        }
      });

      filtardoDiarioEvp.forEach((evapo, key) => {
        const fecha = new Date(evapo.fecha),
          fechaData = new Date(dd.fecha);

        if (
          fecha.getDate() === fechaData.getDate() &&
          fecha.getMonth() === fechaData.getMonth() &&
          fecha.getHours() >= 23 &&
          fechaData.getHours() >= 23
        ) {
          evapoValue = evapo.evapo;
        }
      });

      exportData.push({
        fecha: moment(new Date(dd.fecha)).format("DD/MM/YYYY HH:mm:ss"),
        temp: dd.temp,
        hum: dd.hum,
        pre: dd.pre,
        rad_global: dd.rad_global,
        rad_directa: dd.rad_directa,
        wind_speed: !!dd.wind_speed ? parseFloat(dd.wind_speed).toFixed(2) : 0,
        wind_deg: !!dd.wind_deg ? parseFloat(dd.wind_deg).toFixed(2) : 0,
        clouds: !!dd.clouds ? parseFloat(dd.clouds).toFixed(2) : 0,
        maxs: !!maxValue ? parseFloat(maxValue).toFixed(2) : "",
        mins: !!minValue ? parseFloat(minValue).toFixed(2) : "",
        gdiez: !!gdiezValue ? parseFloat(gdiezValue).toFixed(2) : "",
        evapo: evapoValue,
      });
    });

    this.setState({ exportData, sumaGDias });
  }

  downloadExcel(e): void {
    e.preventDefault();

    if (!this.state.exportData.length) {
      alert(
        "Por favor filtre un periodo de fechas para generar reporte de Climasense"
      );
      return false;
    }

    const style = { alignment: { vertical: "middle" } },
      workbook = new ExcelJs.Workbook(),
      worksheet = workbook.addWorksheet("Resumen"),
      nm_agricultor = _.startCase(this.state.sen.dir.split("/")[3]),
      nm_predio = _.startCase(this.state.sen.dir.split("/")[4]),
      title = `Sensor ${nm_agricultor} - ${nm_predio}`;

    setHeaderExcel(workbook, worksheet, title, "", "SEN");

    worksheet.columns = [
      { key: "fecha", style, width: 23 },
      { key: "temp", style, width: 23 },
      { key: "hum", style, width: 23 },
      { key: "pre", style, width: 23 },
      { key: "rad_global", style, width: 23 },
      { key: "rad_directa", style, width: 23 },
      { key: "wind_speed", style, width: 23 },
      { key: "wind_deg", style, width: 23 },
      { key: "clouds", style, width: 23 },
      { key: "maxs", style, width: 23 },
      { key: "mins", style, width: 23 },
      { key: "gdiez", style, width: 23 },
      { key: "evapo", style, width: 23 },
    ];

    worksheet.addRow({
      fecha: "Fecha",
      temp: "Temperatura Media (°C)",
      hum: "Humedad (%)",
      pre: "Precipitaciones (mm)",
      rad_global: "Radiación Global (W/m2)",
      rad_directa: "Radiación Directa (W/m2)",
      wind_speed: "Velocidad del viento (km/hr)",
      wind_deg: "Dirección del viento (°)",
      clouds: "Nubosidad (%)",
      maxs: "Temperatura Máxima (°C)",
      mins: "Temperatura Mínima (°C)",
      gdiez: "°Días base 10",
      evapo: "Evapotranspiración",
    });

    setTitlesStyles(worksheet, 5, false);

    this.state.exportData.forEach((dd, kk) => {
      worksheet.addRow({
        fecha: dd.fecha,
        temp: dd.temp,
        hum: dd.hum,
        pre: dd.pre,
        rad_global: dd.rad_global,
        rad_directa: dd.rad_directa,
        wind_speed: dd.wind_speed,
        wind_deg: dd.wind_deg,
        clouds: dd.clouds,
        maxs: dd.maxs,
        mins: dd.mins,
        gdiez: dd.gdiez,
        evapo: dd.evapo,
      });

      worksheet.getRow(kk + 6).height = 25; // Estaba en 25

      worksheet.getRow(kk + 6).eachCell((cell, rowNumber) => {
        const even = cell._row._number % 2 === 0;

        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: even ? "FFDEDEDE" : "FFEFEFEF" },
          bgColor: { argb: even ? "FFDEDEDE" : "FFEFEFEF" },
        };
      });
    });

    const lastRowMerge = `A${this.state.exportData.length + 6}:M${
        this.state.exportData.length + 7
      }`,
      lastRow = `A${this.state.exportData.length + 7}`;

    worksheet.mergeCells(lastRowMerge);
    worksheet.getCell(lastRow).value = `Suma °Dias base 10: ${this.snum(
      this.state.sumaGDias
    )}`;
    worksheet.getCell(lastRow).font = {
      bold: true,
      color: { argb: "FFFFFFFF" },
    };
    worksheet.getCell(lastRow).alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell(lastRow).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFe00109" },
      bgColor: { argb: "FFe00109" },
    };
    worksheet.getRow(lastRow).height = 25; // estaba en 25

    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        `${title} data.xls`
      );
    });
  }

  downloadExcelDiario(e): void {
    e.preventDefault();

    if (!this.state.exportData.length) {
      alert(
        "Por favor filtre un periodo de fechas para generar reporte de Climasense"
      );
    }

    const style = { alignment: { vertical: "middle" } },
      workbook = new ExcelJs.Workbook(),
      worksheet = workbook.addWorksheet("Resumen"),
      nm_agricultor = _.startCase(this.state.sen.dir.split("/")[3]),
      nm_predio = _.startCase(this.state.sen.dir.split("/")[4]),
      title = `Sensor ${nm_agricultor} - ${nm_predio}`;

    setHeaderExcel(workbook, worksheet, title, "", "SEN");

    worksheet.columns = [
      { key: "fecha", style, width: 20 },
      { key: "tempMin", style, width: 27 },
      { key: "tempMax", style, width: 27 },
      { key: "tempMean", style, width: 30 },
      { key: "preSum", style, width: 30 },
      { key: "radGlobalSum", style, width: 37 },
      { key: "radDirectaSum", style, width: 37 },
      { key: "windSpeedSum", style, width: 40 },
      { key: "evapoSum", style, width: 25 },
      { key: "humMean", style, width: 27 },
      { key: "cloudsMean", style, width: 27 },
      { key: "gradosDiaSum", style, width: 30 },
    ];

    worksheet.addRow({
      fecha: "Fecha",
      tempMin: "Temperatura mínima (°C)",
      tempMax: "Temperatura máxuma (°C)",
      tempMean: "Temperatura promedio (°C)",
      preSum: "Precipitación acumulada (mm)",
      radGlobalSum: "Radiación global acumulada (W/m2)",
      radDirectaSum: "Radiación directa acumulada (W/m2)",
      windSpeedSum: "Velocidad del viento acumulada (km/hr)",
      evapoSum: "Evapotranspiración",
      humMean: "Humedad promedio (%)",
      cloudsMean: "Nubosidad promedio (%)",
      gradosDiaSum: "Grados día acumulados (°C)",
    });

    setTitlesStyles(worksheet, 5, false);

    this.state.exportDataResumen.forEach((dd, kk) => {
      worksheet.addRow({
        fecha: dd.fecha,
        tempMin: dd.tempMin,
        tempMax: dd.tempMax,
        tempMean: dd.tempMean,
        preSum: dd.preSum,
        radGlobalSum: dd.radGlobalSum,
        radDirectaSum: dd.radDirectaSum,
        windSpeedSum: dd.windSpeedSum,
        evapoSum: dd.evapoSum,
        humMean: dd.humMean,
        cloudsMean: dd.cloudsMean,
        gradosDiaSum: dd.gradosDiaSum,
      });

      worksheet.getRow(kk + 6).height = 25;

      worksheet.getRow(kk + 6).eachCell((cell, rowNumber) => {
        const even = cell._row._number % 2 === 0;

        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: even ? "FFDEDEDE" : "FFEFEFEF" },
          bgColor: { argb: even ? "FFDEDEDE" : "FFEFEFEF" },
        };
      });
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        `${title} data.xlsx`
      );
    });
  }

  getBalloonTextViento(data: Object, graph: Object): string {
    const { value } = data.values,
      fila = _.find(this.state.data.info, {
        fecha: data.serialDataItem.dataContext.fecha,
      });

    if (fila && fila.wind_deg) {
      return `<img src='./img/arrow.png' width='10' height='10' style='transform: rotate(${
        fila.wind_deg || ""
      }deg);' /> ${this.snum(value)} km/hr`;
    } else {
      return `${this.snum(value)} km/hr`;
    }
  }

  FetchLocation = async () => {
    const url = `https://dataservice.accuweather.com/locations/v1/cities/geoposition/search?apikey=${accuKey}&q=${this.state.lat},${this.state.lng}&language=es-cl`,
      response = await (await fetch(url)).json();

    return response;
  };

  FetchWeather = async (locationKey: any) => {
    const url = `https://dataservice.accuweather.com/currentconditions/v1/${locationKey}?apikey=${accuKey}&language=es-cl&details=true`,
      response = (await (await fetch(url)).json())[0];

    return response;
  };

  FetchForecast = async (locationKey: any) => {
    const url = `https://dataservice.accuweather.com/forecasts/v1/daily/5day/${locationKey}?apikey=${accuKey}&language=es-cl&details=true&metric=true`,
      response = (await (await fetch(url)).json()).DailyForecasts;

    return response;
  };

  cargarClima = async () => {
    const location = await this.FetchLocation(),
      current = await this.FetchWeather(location.Key),
      forecast = await this.FetchForecast(location.Key);

    await this.setState({
      current,
      forecast,
      location,
    });
  };

  async check_alertas(sen: T_Sen): Promise<void> {
    if (sen.alertas[0].estado) {
      this.setState({ alertaFito: true });
    }
    if (sen.alertas[1].estado) {
      this.setState({ alertaHelada: true });
    }
  }

  async componentDidMount() {
    //console.log(this.props.app.state)

    await Promise.all([
      this.cargarClima(),
      this.set_graph(this.state.sen),
      this.set_marker(),
    ]);

    await this.setState({ show: true });
    await this.newFiltrarDatos();
    await this.newFiltrarDatosResumen();

    //Funcion pa wena que trae los datos del DBF
    if (this.props.toolbar !== null) {
      const { culti } = this.props.toolbar.state;
      fetch_shp(this.props.app, culti, (response) => {
        if (typeof response === "string") {
          Alert.error(response);
        }

        const superficie = response.dbfRecords
          .map((rec) => rec.HECTAREAS)
          .reduce((a, b) => a + b);
        const espe = response.dbfRecords.map((rec) => rec.ESPECIE);
        var culti = response.dbfRecords.map((rec) => rec.NOMBRE);
        const especie = espe[0];
        var culti = culti[0];
        const cultivo = culti[0].toUpperCase() + culti.slice(1);

        this.setState({ superficie, especie, cultivo });
      });
    }
  }

  mod_suma = (ev: any) => {
    this.setState({ sumatoria: ev.currentTarget.value });
  };

  toggleAlertFito = () => {
    this.setState({
      alertaFito: !this.state.alertaFito,
      alertaHelada: false,
    });
  };

  toggleAlertHelada = () => {
    this.setState({
      alertaFito: false,
      alertaHelada: !this.state.alertaHelada,
    });
  };

  submitHelada = (event) => {
    event.preventDefault();

    const tab = 1,
      myAlertas = this.state.sen.alertas[tab],
      superficie = parseFloat(this.state.superficie),
      especie =
        this.state.especie.charAt(0).toUpperCase() +
        this.state.especie.slice(1),
      cloneAlertas = _.cloneDeep(this.state.sen.alertas),
      newCloneAlerta = cloneAlertas[tab],
      senPath = this.props.app.state.node_path,
      alertaHeladaID = myAlertas.id,
      { sen } = this.props.app.state,
      { app } = this.props,
      data = new FormData(event.target),
      name = "Helada",
      tMax = data.get("tMax");
    // userId = this.props.app.props.user.id;
    //console.log("superficie",superficie);
    //console.log("especie",especie);
    let state = data.get("activateSwitch");

    const valid_email = validator.validate(this.props.email);

    if (name !== "" && valid_email && tMax > 0) {
      if (state === "on") {
        state = true;
        this.setState({ alertaHelada: true });
      } else {
        state = false;
        this.setState({ alertaHelada: false });
      }

      if (sen.file === "") {
        /* eslint-disable prefer-template */
        sen.file = `${sen.titulo.replace(/ /g, "_")}-${Date.now()}-${(
          Math.random() + ""
        ).slice(2)}.sensor`;
        /* eslint-enable prefer-template */
        sen.path = `${sen.dir}/${sen.file}`;
      }
      sen.alertas[tab] = myAlertas;

      newCloneAlerta.nombre = name;
      newCloneAlerta.email = this.props.email;
      newCloneAlerta.temp_ref = parseFloat(tMax);
      newCloneAlerta.temp_opt = "menor";
      newCloneAlerta.estado = state;

      sen.alertas[tab].nombre = name;
      sen.alertas[tab].email = this.props.email;
      sen.alertas[tab].temp_ref = parseFloat(tMax);
      sen.alertas[tab].temp_opt = "menor";
      sen.alertas[tab].estado = state;
      sen.alertas[tab].hum_ref = 0;

      sen.alertas[tab].especie = especie;
      sen.alertas[tab].superficie = superficie;

      app.setState({ sen });
      $.ajax({
        type: "POST",
        url: `${
          app.remote
        }/post-sensor/?session_id=${app.session()}&path=${senPath}&id_alerta=${alertaHeladaID}&tab=${tab}`,
        dataType: "json",
        async: true,
        data: { sensor: JSON.stringify(sen) },
      })
        .done(async (res) => {
          if (res.error) {
            Alert.error("No se pudo guardar la alerta.", {
              position: "bottom-left",
            });
          } else {
            cloneAlertas[tab] = res.sensor.alertas[tab];
            this.setState({
              sen: res.sensor,
              alertas: cloneAlertas,
            });

            app.setState({ sen: res.sensor });

            await app.reload_dir(sen.dir, (resp) => {
              const item_sen = app.get_item_sen(res.sensor.path);

              if (item_sen != null) {
                item_sen.open();
              }
            });

            if (sen.id === 0) {
              Alert.success("Sensor creado con exito", {
                position: "bottom-left",
              });
            } else if (alertaHeladaID > 0) {
              Alert.success("Alerta modificada con exito", {
                position: "bottom-left",
              });
            } else {
              Alert.success("Alerta creada con exito", {
                position: "bottom-left",
              });
            }
          }
        })
        .fail((err) => {
          Alert.error("Hubo un error en el proceso", {
            position: "bottom-left",
          });
        });
    }
  };

  submitFito = (event) => {
    event.preventDefault();
    const tab = 0,
      myAlertas = this.state.sen.alertas[tab],
      cloneAlertas = _.cloneDeep(this.state.sen.alertas),
      newCloneAlerta = cloneAlertas[tab],
      senPath = this.props.app.state.node_path,
      alertaFitoID = myAlertas.id,
      { sen } = this.props.app.state,
      { app } = this.props,
      data = new FormData(event.target),
      name = "Fitosanitaria",
      tMax = data.get("tMaxFito"),
      humd = data.get("humFito");
    // userId = this.props.app.props.user.id;

    let state = data.get("activateSwitchFito");

    const valid_email = validator.validate(this.props.email);

    if (name !== "" && humd !== "" && valid_email && tMax > 0) {
      if (state === "on") {
        state = true;
        this.setState({ alertaFito: true });
      } else {
        state = false;
        this.setState({ alertaFito: false });
      }
      if (sen.file === "") {
        /* eslint-disable prefer-template */
        sen.file = `${sen.titulo.replace(/ /g, "_")}-${Date.now()}-${(
          Math.random() + ""
        ).slice(2)}.sensor`;
        /* eslint-enable prefer-template */
        sen.path = `${sen.dir}/${sen.file}`;
      }
      sen.alertas[tab] = myAlertas;

      newCloneAlerta.nombre = name;
      newCloneAlerta.email = this.props.email;
      newCloneAlerta.temp_ref = parseFloat(tMax);
      newCloneAlerta.temp_opt = "mayor";
      newCloneAlerta.hum_ref = parseFloat(humd);
      newCloneAlerta.hum_opt = "mayor";
      newCloneAlerta.estado = state;

      sen.alertas[tab].nombre = name;
      sen.alertas[tab].email = this.props.email;
      sen.alertas[tab].temp_ref = parseFloat(tMax);
      sen.alertas[tab].temp_opt = "mayor";
      sen.alertas[tab].hum_ref = humd;
      sen.alertas[tab].hum_opt = "mayor";
      sen.alertas[tab].estado = state;

      $.ajax({
        type: "POST",
        url: `${
          app.remote
        }/post-sensor/?session_id=${app.session()}&path=${senPath}&id_alerta=${alertaFitoID}&tab=${tab}`,
        dataType: "json",
        async: true,
        data: { sensor: JSON.stringify(sen) },
      })
        .done(async (res) => {
          if (res.error) {
            Alert.error("No se pudo guardar la alerta.", {
              position: "bottom-left",
            });
          } else {
            cloneAlertas[tab] = res.sensor.alertas[tab];

            this.setState({
              sen: res.sensor,
              alertas: cloneAlertas,
            });

            app.setState({ sen: res.sensor });

            await app.reload_dir(sen.dir, (resp) => {
              const item_sen = app.get_item_sen(res.sensor.path);

              if (item_sen != null) {
                item_sen.open();
              }
            });

            if (sen.id === 0) {
              Alert.success("Sensor creado con exito", {
                position: "bottom-left",
              });
            } else if (alertaFitoID > 0) {
              Alert.success("Alerta modificada con exito", {
                position: "bottom-left",
              });
            } else {
              Alert.success("Alerta creada con exito", {
                position: "bottom-left",
              });
            }
          }
        })
        .fail((err) => {
          Alert.error("Hubo un error en el proceso", {
            position: "bottom-left",
          });
        });
    }
  };

  renderRow(item, index) {
    return (
      <tr key={`export_${index}`}>
        {/* <td>{moment(new Date(item.fecha)).format('DD/MM/YYYY HH:mm:ss')}</td> */}
        <td>{item.fecha}</td>
        <td>{item.temp}</td>
        <td>{item.hum}</td>
        <td>{item.pre}</td>
        <td>{item.rad_global}</td>
        {/* <td>{item.rad_directa}</td> */}
        <td>{item.wind_speed}</td>
        {/* <td>{item.wind_deg}</td> */}
        {/* <td>{item.clouds}</td> */}
        <td>{item.maxs}</td>
        <td>{item.mins}</td>
        {/* <td>{item.gdiez}</td> */}
        <td>{item.evapo}</td>
      </tr>
    );
  }

  renderTable() {
    return (
      <table>
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Temperatura Media (°C)</th>
            <th>Humedad (%)</th>
            <th>Precipitaciones (mm)</th>
            <th>Radiación Global (W/m2)</th>
            {/* <th>Radiación Directa (W/m2)</th> */}
            <th>Velocidad del viento (km/hr)</th>
            {/* <th>Dirección del viento (°)</th> */}
            {/* <th>Nubosidad (%)</th> */}
            <th>Temperatura Máxima (°C)</th>
            <th>Temperatura Mínima (°C)</th>
            {/* <th>°Días base 10</th> */}
            <th>Evapotranspiración</th>
          </tr>
        </thead>
        <tbody>{this.state.exportData.map(this.renderRow)}</tbody>
        <tfoot>
          <tr>
            <th>Fecha</th>
            <th>Temperatura Media (°C)</th>
            <th>Humedad (%)</th>
            <th>Precipitaciones (mm)</th>
            <th>Radiación Global (W/m2)</th>
            {/* <th>Radiación Directa (W/m2)</th> */}
            <th>Velocidad del viento (km/hr)</th>
            {/* <th>Dirección del viento (°)</th> */}
            {/* <th>Nubosidad (%)</th> */}
            <th>Temperatura Máxima (°C)</th>
            <th>Temperatura Mínima (°C)</th>
            {/* <th>°Días base 10</th> */}
            <th>Evapotranspiración</th>
          </tr>
        </tfoot>
      </table>
    );
  }

  render() {
    const { sen, visible, alertas } = this.state,
      { app } = this.props,
      left =
        sen.file === ""
          ? SIDEBAR_WIDTH + 10
          : SIDEBAR_WIDTH + CLASSIC_WIDTH + 15,
      menosW = sen.file === "" ? this.props.width / 2 : 10,
      width = this.props.width - left - menosW,
      top = sen.file === "" ? this.props.height / 2 : 50,
      menosH = sen.file === "" ? 0 : 10,
      height = this.props.height - top - menosH,
      { current } = this.state,
      { forecast } = this.state,
      icons = [];
    for (const [i, icon] of forecast.entries()) {
      if (i === 0) {
        icons.push(`${current.WeatherIcon}`);
      } else {
        icons.push(`${icon.Day.Icon}`);
      }
    }

    if (visible) {
      return (
        <Draggable disabled={sen.file === ""} handle="strong">
          <div
            onContextMenu={no_rclick}
            className="sensor_dialog"
            style={{ left, top, width, height }}
          >
            <div className="modal">
              <div className="dclose2 textRight padding dark climaSense_UPL">
                <img className="iconClima" src={iconClimaSense} alt="" />
                <div className="climaTitle textTitle" />
                {this.state.show && this.state.sen.dir.includes("UPL") && (
                  <img className="iconUPL" src={iconUPL} alt="" />
                )}
                <div style={{ height: "auto", paddingTop: "5px" }}>
                  <Icon name="times-circle" size="lg" onClick={this.close} />
                </div>
              </div>
              <div className="overflow">
                <div className="climaSense">
                  <div className="title">PRONÓSTICO CLIMÁTICO</div>
                  <div className="foreCasting">
                    {forecast.map((day, index) => {
                      const imageRoute: string = require(`./css/img/newWeatherIcons/${icons[index]}.svg`);

                      if (index === 0) {
                        return (
                          // Container
                          <div key={index} className="todayWeather">
                            <div className="todayWeatherTitle">
                              <h4>
                                HOY{" "}
                                {moment(day.Date).format("dddd").toUpperCase()}
                              </h4>
                            </div>
                            <div className="todayWeatherImage">
                              <img
                                src={imageRoute}
                                alt={"iconWeather"}
                                style={{ height: "110px", alignSelf: "center" }}
                              />
                              {/* <div className="todayWeatherStatusTemp"> */}
                              <h3
                                style={{
                                  alignSelf: "center",
                                  marginBottom: "25px",
                                }}
                              >
                                {current.Temperature.Metric.Value} ºC
                              </h3>
                              {/* </div> */}
                              {/* <div className="todayWeatherStatusText"> */}
                              <p
                                style={{
                                  alignSelf: "center",
                                  margin: "auto 20px",
                                }}
                              >
                                {current.WeatherText}
                              </p>
                              {/* </div> */}
                            </div>
                            <div className="todayWeatherInfo">
                              <div>
                                <div className="dataContainer">
                                  <div className="mainData myBorder">
                                    <h4>Tº Max:</h4>
                                    <h4>
                                      <b>{day.Temperature.Maximum.Value}°C</b>
                                    </h4>
                                  </div>
                                  <div className="mainData myBorder">
                                    <h4>Tº Min:</h4>
                                    <h4>
                                      <b>{day.Temperature.Minimum.Value}ºC</b>
                                    </h4>
                                  </div>
                                  <div className="mainData myBorder">
                                    <h4>Viento:</h4>
                                    <h4>
                                      <b>
                                        {day.Day.Wind.Speed.Value +
                                          day.Day.Wind.Speed.Unit}
                                      </b>
                                    </h4>
                                  </div>
                                  <div className="mainData">
                                    <h4>Prob. Precipitación:</h4>
                                    <h4>
                                      <b>{day.Day.PrecipitationProbability}%</b>
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                      return (
                        <div key={index} className="dataForecast">
                          <div className="dayIcon">
                            <img
                              src={imageRoute}
                              alt={"iconWeather"}
                              style={{ height: "80px" }}
                            />
                          </div>
                          <div className="dayStatus">
                            <h4>
                              <b>
                                <br />
                                {moment(day.Date).format("dddd").toUpperCase()}
                              </b>
                            </h4>
                            <p>{day.Day.LongPhrase}</p>
                          </div>
                          <div className="dataContainer">
                            <div className="mainData myBorder">
                              <h4>Tº Max:</h4>
                              <h4>
                                <b>{day.Temperature.Maximum.Value}°C</b>
                              </h4>
                            </div>
                            <div className="mainData myBorder">
                              <h4>Tº Min:</h4>
                              <h4>
                                <b>{day.Temperature.Minimum.Value}ºC</b>
                              </h4>
                            </div>
                            <div className="mainData myBorder">
                              <h4>Viento:</h4>
                              <h4>
                                <b>
                                  {day.Day.Wind.Speed.Value +
                                    day.Day.Wind.Speed.Unit}
                                </b>
                              </h4>
                            </div>
                            <div className="mainData">
                              <h4>Prob. Precipitación:</h4>
                              <h4>
                                <b>{day.Day.PrecipitationProbability}%</b>
                              </h4>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                {this.state.show && this.state.sen.dir.includes("UPL") && (
                  <div id="testOpener" className="vClimaticas3_UPL">
                    <div className="title">ALERTAS</div>
                    {/* {this.state.show && this.state.sen.dir.includes('UPL') && ( */}
                    <div className="vClima UPL fixHeight fixplusUPL border border-bottom">
                      <div className="subTitle_UPL">
                        <p>CONTROL FITOSANITARIO</p>
                        <div className="toolTip tooltip-cf">
                          <img src={tooltip} alt="" className="tooltip-icon" />
                          <span
                            className="tooltip-text tooltip-bottom"
                            style={{ left: "-98%" }}
                          >
                            <p>
                              Módulo que le permite activar alertas de riesgo de
                              ocurrencia de enfermedades y/o plagas más
                              relevantes de su cultivo.
                            </p>
                          </span>
                        </div>
                      </div>
                      <DialogSensorUPL
                        app={this.props.app}
                        data={this.state.data.info}
                        data_diaria={this.state.data.data_diaria}
                        email={this.props.email}
                        sen={this.state.sen}
                        toolbar={this.props.toolbar}
                      />
                    </div>
                    {/* )} */}
                    <div className="vClima fixHeight fixplus border">
                      <div className="subTitle">
                        <p>SUMA HRS FRÍO (Hrs)</p>
                        <div className="toolTip">
                          <img src={tooltip} alt="" className="tooltip-icon" />
                          <span className="tooltip-text tooltip-bottom">
                            <p>
                              Entrega la cantidad de horas en que el frutal ha
                              estado expuesto a una temperatura bajo el umbral
                              de 7°C.
                            </p>
                          </span>
                        </div>
                      </div>
                      {this.state.show && (
                        <HoraFrio
                          valor={this.state.data.info}
                          sensor={this.state.sen}
                          suma={this.state.sumaFrio}
                          fecha={this.state.fechaFrio}
                          app={this.props.app}
                        />
                      )}
                    </div>
                    <div className="vClima fixHeight fixplus border-right">
                      <div className="subTitle">
                        <p>SUMA GRADOS BASE 10 (ºC)</p>
                        <div className="toolTip">
                          <img src={tooltip} alt="" className="tooltip-icon" />
                          <span className="tooltip-text tooltip-bottom">
                            <p>
                              Corresponden a la diferencia entre la temperatura
                              media diaria por sobre o bajo los 10°C.
                            </p>
                          </span>
                        </div>
                      </div>
                      {this.state.show && (
                        <Base10
                          valores={this.state.data.diaria.gdiez}
                          sensor={this.state.sen}
                          suma={this.state.sumaDiez}
                          fecha={this.state.fechaDiez}
                          app={this.props.app}
                        />
                      )}
                    </div>
                    <div className="vClima fixHeight">
                      <div className="alertaTitle">
                        {/* <div>
                    <img src={iconHelada} className="iconAlerta" alt="Alerta Helada"/>
                  </div> */}
                        <p>HELADA</p>
                        <div className="toolTip">
                          <img src={tooltip} alt="" className="tooltip-icon" />
                          <span className="tooltip-text tooltip-bottom">
                            <p>Configura una alerta de ocurrencia de helada.</p>
                          </span>
                        </div>
                      </div>
                      <div className="alertaContainer">
                        {/* <img
                          src={iconHelada}
                          className="iconAlerta"
                          alt="Alerta Helada"
                        /> */}
                        <form onSubmit={this.submitHelada}>
                          <div className="alertaContainerInput fixMargin">
                            <span>Temperatura Crítica</span>
                            <input
                              type="number"
                              name="tMax"
                              min="0"
                              defaultValue={
                                this.state.alerta && alertas[1].id > 0
                                  ? alertas[1].temp_ref
                                  : ""
                              }
                            />
                          </div>
                          {/* <div className="alertaContainerInput">
                          <span>Email</span>
                          <input type="email" name="email" placeholder={this.props.alertas && this.props.alertas[1].id > 0 ? this.props.alertas[1].email : ''} />
                          </div> */}
                          <div className="alertaContainerInput alertaContainerActivar">
                            <span>Activar</span>
                            <label className="switch">
                              <input
                                type="checkbox"
                                name="activateSwitch"
                                defaultChecked={
                                  this.state.alerta &&
                                  app.state.sen.alertas[1].estado !== true
                                    ? false
                                    : true
                                }
                              />
                              <span className="sliderUPL round" />
                            </label>
                          </div>
                          <div className="alertaContainerInput alertaContainerActivar">
                            <button className="sendButton">Guardar</button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="vClima fixHeight border">
                      <div className="alertaTitle">
                        {/* <div>
                    <img src={iconFito} className="iconAlerta rotateIcon" alt="Alerta Fito"/>
                  </div> */}
                        <p>FITOSANITARIA</p>
                        <div className="toolTip">
                          <img src={tooltip} alt="" className="tooltip-icon" />
                          <span className="tooltip-text tooltip-bottom">
                            <p>Configura una alerta fitosanitaria.</p>
                          </span>
                        </div>
                      </div>
                      <div className="alertaContainer">
                        {/* <img
                          src={iconFito}
                          className="iconAlerta fixSize rotateIcon"
                          alt="Alerta Fito"
                        /> */}
                        <form onSubmit={this.submitFito}>
                          <div className="alertaContainerInput margin-top">
                            <span>Temperatura Crítica</span>
                            <input
                              type="number"
                              name="tMaxFito"
                              min="0"
                              defaultValue={
                                this.state.alerta && alertas[0].id > 0
                                  ? alertas[0].temp_ref
                                  : ""
                              }
                            />
                          </div>
                          <div className="alertaContainerInput">
                            <span>Humedad</span>
                            <input
                              type="number"
                              name="humFito"
                              min="0"
                              defaultValue={
                                this.state.alerta && alertas[0].id > 0
                                  ? alertas[0].hum_ref
                                  : ""
                              }
                            />
                          </div>
                          {/* <div className="alertaContainerInput">
                        <span>Email</span>
                        <input type="email" name="emailFito" placeholder={this.props.alertas && this.props.alertas[0].id > 0 ? this.state.alertas[0].email : ''} />
                      </div> */}
                          <div className="alertaContainerInput alertaContainerActivar">
                            <span>Activar</span>
                            <label className="switch">
                              <input
                                type="checkbox"
                                name="activateSwitchFito"
                                defaultChecked={
                                  this.state.alerta &&
                                  app.state.sen.alertas[0].estado !== true
                                    ? false
                                    : true
                                }
                              />
                              <span className="sliderUPL round" />
                            </label>
                          </div>
                          <div className="alertaContainerInput alertaContainerActivar">
                            <button className="sendButton">Guardar</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                )}
                <div className="vClimaticas">
                  <div className="title">VARIABLES CLIMÁTICAS</div>
                  <div className="vClima border">
                    <div className="subTitle">
                      <p>TEMPERATURA (ºC)</p>
                      <div className="toolTip">
                        <img src={tooltip} alt="" className="tooltip-icon" />
                        <span className="tooltip-text tooltip-bottom">
                          <p>
                            Se entrega la información de temperatura media,
                            máxima y mínima expresada en °C.
                          </p>
                        </span>
                      </div>
                    </div>
                    {this.state.show && (
                      <Temperatura data={this.state.data.data_diaria} />
                    )}
                  </div>
                  <div className="vClima">
                    <div className="subTitle">
                      <p>HUMEDAD RELATIVA (%)</p>
                      <div className="toolTip">
                        <img src={tooltip} alt="" className="tooltip-icon" />
                        <span className="tooltip-text tooltip-bottom">
                          <p>
                            Se entrega la humedad relativa media, máxima y
                            mínima expresada en porcentaje.
                          </p>
                        </span>
                      </div>
                    </div>
                    {this.state.show && (
                      <Humedad data={this.state.data.data_diaria} />
                    )}
                  </div>
                  <div className="vClima border">
                    <div className="subTitle">
                      <p>PRECIPITACIÓN (mm)</p>
                      <div className="toolTip">
                        <img src={tooltip} alt="" className="tooltip-icon" />
                        <span className="tooltip-text tooltip-bottom">
                          <p>Se entrega la precipitación expresada en mm.</p>
                        </span>
                      </div>
                    </div>
                    {this.state.show && (
                      <Precipitacion data={this.state.data.data_diaria} />
                    )}
                  </div>
                </div>
                <div className="vClimaticas2">
                  <div className="title">VARIABLES AGROCLIMÁTICAS</div>
                  <div className="vClima border-left">
                    <div className="subTitle">
                      <p>EVAPOTRANSPIRACIÓN (mm)</p>
                      <div className="toolTip tooltip-vac">
                        <img src={tooltip} alt="" className="tooltip-icon" />
                        <span className="tooltip-text tooltip-bottom">
                          <p>
                            Expresa el poder evaporante de la atmósfera en una
                            localidad y época del año específicas (no considera
                            las características del culltivo ni los factores del
                            suelo).
                          </p>
                        </span>
                      </div>
                    </div>
                    {this.state.show && (
                      <Evapo data={this.state.data.diaria.evapo} />
                    )}
                  </div>
                  <div className="vClima border">
                    <div className="subTitle">
                      <p>BALANCE HÍDRICO (mm)</p>
                      <div className="toolTip tooltip-vac">
                        <img src={tooltip} alt="" className="tooltip-icon" />
                        <span className="tooltip-text tooltip-bottom">
                          <p>
                            Entrega la diferencia entre precipitación y
                            evapotranspiración como una referencia para la
                            cantidad de agua necesaria a aportar mediante riego.
                          </p>
                        </span>
                      </div>
                    </div>
                    {this.state.show && (
                      <EvapoPre
                        data={this.state.data.info}
                        data_diaria={this.state.data.diaria.evapo}
                      />
                    )}
                  </div>
                  <div className="vClima DPV border-left">
                    <div className="subTitle">
                      <p>DÉFICIT DE PRESIÓN DE VAPOR (hPa)</p>
                      <div className="toolTip tooltip-vac">
                        <img src={tooltip} alt="" className="tooltip-icon" />
                        <span className="tooltip-text tooltip-bottom">
                          <p>
                            Entrega la cantidad de vapor de agua que se requiere
                            en un determinado momento para saturar la atmósfera.
                          </p>
                        </span>
                      </div>
                    </div>
                    {this.state.show && <DPV data={this.state.data.dpv} />}
                  </div>
                  <div className="vClima MH border">
                    <div className="subTitle">
                      <p>MOJAMIENTO DE HOJA</p>
                      <div className="toolTip tooltip-vac">
                        <img src={tooltip} alt="" className="tooltip-icon" />
                        <span className="tooltip-text tooltip-bottom">
                          <p>
                            Ocurrencia o duración de la presencia de agua
                            líquida en la superficie de las hojas.
                          </p>
                        </span>
                      </div>
                    </div>
                    {this.state.show && <MojaHoja data={this.state.data.mh} />}
                  </div>
                </div>
                {this.state.show && !this.state.sen.dir.includes("UPL") && (
                  <div className="vClimaticas3">
                    <div className="title">ALERTAS</div>
                    {this.state.show && this.state.sen.dir.includes("UPL") && (
                      <div className="vClima UPL fixHeight fixplusUPL border border-bottom">
                        <div className="subTitle_UPL">
                          <p>CONTROL FITOSANITARIO</p>
                          <div className="toolTip tooltip-cf">
                            <img
                              src={tooltip}
                              alt=""
                              className="tooltip-icon"
                            />
                            <span
                              className="tooltip-text tooltip-bottom"
                              style={{ left: "-98%" }}
                            >
                              <p>Descripción control fitosanitario.</p>
                            </span>
                          </div>
                        </div>
                        <DialogSensorUPL
                          app={this.props.app}
                          data={this.state.data.info}
                          data_diaria={this.state.data.data_diaria}
                          email={this.props.email}
                          sen={this.state.sen}
                          toolbar={this.props.toolbar}
                        />
                      </div>
                    )}
                    <div className="vClima fixHeight fixplus border">
                      <div className="subTitle">
                        <p>SUMA HRS FRÍO (Hrs)</p>
                        <div className="toolTip">
                          <img src={tooltip} alt="" className="tooltip-icon" />
                          <span className="tooltip-text tooltip-bottom">
                            <p>
                              Entrega la cantidad de horas en que el frutal ha
                              estado expuesto a una temperatura bajo el umbral
                              de 7°C.
                            </p>
                          </span>
                        </div>
                      </div>
                      {this.state.show && (
                        <HoraFrio
                          valor={this.state.data.info}
                          sensor={this.state.sen}
                          suma={this.state.sumaFrio}
                          fecha={this.state.fechaFrio}
                          app={this.props.app}
                        />
                      )}
                    </div>
                    <div className="vClima fixHeight fixplus border-right">
                      <div className="subTitle">
                        <p>SUMA GRADOS BASE 10 (ºC)</p>
                        <div className="toolTip">
                          <img src={tooltip} alt="" className="tooltip-icon" />
                          <span className="tooltip-text tooltip-bottom">
                            <p>
                              Corresponden a la diferencia entre la temperatura
                              media diaria por sobre o bajo los 10°C.
                            </p>
                          </span>
                        </div>
                      </div>
                      {this.state.show && (
                        <Base10
                          valores={this.state.data.diaria.gdiez}
                          sensor={this.state.sen}
                          suma={this.state.sumaDiez}
                          fecha={this.state.fechaDiez}
                          app={this.props.app}
                        />
                      )}
                    </div>
                    <div className="vClima fixHeight">
                      <div className="alertaTitle">
                        {/* <div>
                    <img src={iconHelada} className="iconAlerta" alt="Alerta Helada"/>
                  </div> */}
                        <p>HELADA</p>
                        <div className="toolTip">
                          <img src={tooltip} alt="" className="tooltip-icon" />
                          <span className="tooltip-text tooltip-bottom">
                            <p>Configura una alerta de ocurrencia de helada.</p>
                          </span>
                        </div>
                      </div>
                      <div className="alertaContainer">
                        {/* <img
                          src={iconHelada}
                          className="iconAlerta"
                          alt="Alerta Helada"
                        /> */}
                        <form onSubmit={this.submitHelada}>
                          <div className="alertaContainerInput fixMargin">
                            <span>Temperatura Crítica</span>
                            <input
                              type="number"
                              name="tMax"
                              min="0"
                              defaultValue={
                                this.state.alerta && alertas[1].id > 0
                                  ? alertas[1].temp_ref
                                  : ""
                              }
                            />
                          </div>
                          {/* <div className="alertaContainerInput">
                        <span>Email</span>
                        <input type="email" name="email" placeholder={this.props.alertas && this.props.alertas[1].id > 0 ? this.props.alertas[1].email : ''} />
                      </div> */}
                          <div className="alertaContainerInput alertaContainerActivar">
                            <span>Activar</span>
                            <label className="switch">
                              <input
                                type="checkbox"
                                name="activateSwitch"
                                defaultChecked={
                                  this.state.alerta &&
                                  app.state.sen.alertas[1].estado !== true
                                    ? false
                                    : true
                                }
                              />
                              <span className="slider round" />
                            </label>
                          </div>
                          <div className="alertaContainerInput alertaContainerActivar">
                            <button className="sendButton">Guardar</button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="vClima fixHeight border">
                      <div className="alertaTitle">
                        {/* 
                          <div>
                            <img src={iconFito} className="iconAlerta rotateIcon" alt="Alerta Fito"/>
                          </div> 
                        */}
                        <p>FITOSANITARIA</p>
                        <div className="toolTip">
                          <img src={tooltip} alt="" className="tooltip-icon" />
                          <span className="tooltip-text tooltip-bottom">
                            <p>Configura una alerta fitosanitaria.</p>
                          </span>
                        </div>
                      </div>
                      <div className="alertaContainer">
                        {/* <img
                          src={iconFito}
                          className="iconAlerta fixSize rotateIcon"
                          alt="Alerta Fito"
                        /> */}
                        <form onSubmit={this.submitFito}>
                          <div className="alertaContainerInput margin-top">
                            <span>Temperatura Crítica</span>
                            <input
                              type="number"
                              name="tMaxFito"
                              min="0"
                              defaultValue={
                                this.state.alerta && alertas[0].id > 0
                                  ? alertas[0].temp_ref
                                  : ""
                              }
                            />
                          </div>
                          <div className="alertaContainerInput">
                            <span>Humedad</span>
                            <input
                              type="number"
                              name="humFito"
                              min="0"
                              defaultValue={
                                this.state.alerta && alertas[0].id > 0
                                  ? alertas[0].hum_ref
                                  : ""
                              }
                            />
                          </div>
                          {/* 
                            <div className="alertaContainerInput">
                              <span>Email</span>
                              <input type="email" name="emailFito" placeholder={this.props.alertas && this.props.alertas[0].id > 0 ? this.state.alertas[0].email : ''} />
                            </div> 
                          */}
                          <div className="alertaContainerInput alertaContainerActivar">
                            <span>Activar</span>
                            <label className="switch">
                              <input
                                type="checkbox"
                                name="activateSwitchFito"
                                defaultChecked={
                                  this.state.alerta &&
                                  app.state.sen.alertas[0].estado !== true
                                    ? false
                                    : true
                                }
                              />
                              <span className="slider round" />
                            </label>
                          </div>
                          <div className="alertaContainerInput alertaContainerActivar">
                            <button className="sendButton">Guardar</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                )}
                <div className="vExport">
                  <div className="title">EXPORTAR DATOS</div>
                  <div className="vFormExport border">
                    <form id="export" action="">
                      <label htmlFor="from">
                        <span> Desde:</span>
                        <input
                          type="date"
                          name="from"
                          id="from"
                          value={this.state.from}
                          max={this.state.to}
                          onChange={(e) =>
                            this.setState({ from: e.target.value })
                          }
                        />
                      </label>
                      <label htmlFor="to">
                        <span> Hasta:</span>
                        <input
                          type="date"
                          name="to"
                          id="to"
                          value={this.state.to}
                          min={this.state.from}
                          max={moment().format("YYYY-MM-DD")}
                          onChange={(e) =>
                            this.setState({ to: e.target.value })
                          }
                        />
                      </label>
                      <button
                        className="sendButton climaExport"
                        onClick={(e) => this.handleFiltrar(e)}
                      >
                        Filtrar
                      </button>
                      <button
                        className="sendButton climaExport"
                        onClick={(e) => this.downloadExcelDiario(e)}
                      >
                        Exportar Resumen
                      </button>
                      <button
                        className="sendButton climaExport"
                        onClick={(e) => this.downloadExcel(e)}
                      >
                        Exportar Todo
                      </button>
                    </form>
                  </div>
                  <div className="vTable border">
                    {this.state.exportData.length > 0 ? (
                      this.renderTable()
                    ) : (
                      <p>No existen registros</p>
                    )}
                  </div>
                </div>
              </div>

              {/* 
                <div className="buttonAlerta1"> 
                  <button name="alertaFito" onClick={this.toggleAlertFito}>
                    <img src={iconFito} alt="IconoFito" title="Alerta Fitosanitaria" />
                  </button>
                </div>

                <div className="buttonAlerta2"> 
                  <button name="alertaHumedad" onClick={this.toggleAlertHelada}>
                    <img src={iconHelada} alt="IconoHelada" title="Alerta Helada"/>
                  </button>
                </div> 
              */}
            </div>
          </div>
        </Draggable>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/DialogSensor.jsx